import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { modelAGF } from "../hooks/useModel";

const EfficiencyByAreaChart = ({
  rentalRate,
  loanAmount,
  interestRate,
  loanPeriod,
  checkbox,
  keyRate,
  discountRate,
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const areas = [];
    const efficiencies = [];
    const benchmark = [];

    for (let s = 700; s <= 2500; s += 100) {
      areas.push(s);
      const m = modelAGF(
        s,
        rentalRate,
        loanAmount,
        interestRate / 100,
        loanPeriod,
        checkbox,
        keyRate,
      );
      const eff = m.meanProfitabilityI ? m.meanProfitabilityI * 100 : 0;
      efficiencies.push(eff);
      benchmark.push(discountRate * 100);
    }

    if (chartInstance.current) chartInstance.current.destroy();

    chartInstance.current = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels: areas,
        datasets: [
          {
            label: "Эффективность вложений",
            data: efficiencies,
            borderColor: "black",
            borderWidth: 3,
            fill: false,
            tension: 0.4,
            pointRadius: 0,
          },
          {
            label: "Эталонная ставка для сравнения",
            data: benchmark,
            borderColor: "rgb(255, 99, 132)",
            borderWidth: 2,
            borderDash: [5, 5],
            fill: false,
            tension: 0,
            pointRadius: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          title: {
            display: true,
            text: "Анализ эффективности вложений от Площади",
            font: {
              family: "Montserrat, sans-serif",
              size: 16,
              weight: "bold",
            },
          },
          legend: {
            position: "bottom",
            labels: { font: { family: "Montserrat, sans-serif", size: 10 } },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: "Показатель эффективности, %" },
            ticks: { callback: (val) => val + "%" },
          },
          x: {
            title: { display: true, text: "Площадь помещения, м²" },
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [
    rentalRate,
    loanAmount,
    interestRate,
    loanPeriod,
    checkbox,
    keyRate,
    discountRate,
  ]);

  return (
    <canvas ref={chartRef} style={{ width: "100%", maxHeight: "400px" }} />
  );
};

export default EfficiencyByAreaChart;
